import { withPublic } from '@hocs/withPublic';

import { SignInView } from '@auth/views';

const SignIn = () => <SignInView />;

export default withPublic(SignIn);
